import { useAuthStore } from '~/stores/auth'

export default defineNuxtRouteMiddleware(() => {
  const authStore = useAuthStore()
  if (!authStore.canManageCompany) {
    return navigateTo({ name: 'dashboard' })
  }

  return null
})
